__turbopack_context__.v({
  "fadeIn": "interactive-object-links-rich-text-module-scss-module__KVwr3q__fadeIn",
  "highlightedObject": "interactive-object-links-rich-text-module-scss-module__KVwr3q__highlightedObject",
  "objectWrapper": "interactive-object-links-rich-text-module-scss-module__KVwr3q__objectWrapper",
  "text": "interactive-object-links-rich-text-module-scss-module__KVwr3q__text",
});
